import { api } from './api'

/**
 * Autopay (B8): the direct-debit mandate that renews Tooti+ monthly. Real
 * money crosses the wire as a decimal string (`monthlyCapMinor`, minor
 * units — Rial), never a float.
 */

export async function autopayStatus() {
  const { data } = await api.get('/autopay/status')
  return data
}

/** [ibanTail] is the last 4 digits only — the full IBAN never reaches this service. */
export async function createMandate({ bank, ibanTail, monthlyCapMinor, withdrawalDay, remindEnabled }) {
  const { data } = await api.post('/autopay/create-mandate', { bank, ibanTail, monthlyCapMinor, withdrawalDay, remindEnabled })
  return data
}

export async function cancelMandate() {
  const { data } = await api.post('/autopay/cancel-mandate', {})
  return data
}
